import { SvgIcon, SvgIconProps} from '@mui/material';
import './ccf-elevated-email-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfElevatedEmailIconProps extends SvgIconProps {}

/**
 *
 * @param props -
 * @example
 * @returns
 */
export function CcfElevatedEmailIcon(props: CcfElevatedEmailIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        d="M15.018 0.237341C14.7863 0.0769361 14.5098 -0.00602444 14.228 0.000340714H1.58004C1.29829 -0.00602444 1.02176 0.0769361 0.790039 0.237341L7.90404 4.66434L15.018 0.237341Z"
        fill="#007AB8"
      />
      <path
        d="M15.809 1.5813L8.3 6.2453C8.16835 6.27956 8.03478 6.30594 7.9 6.3243C7.75172 6.32287 7.60923 6.26658 7.5 6.1663L0 1.5813V9.4813C0.00131855 9.9002 0.168311 10.3016 0.464521 10.5978C0.76073 10.894 1.1621 11.061 1.581 11.0623H14.228C14.6469 11.061 15.0483 10.894 15.3445 10.5978C15.6407 10.3016 15.8077 9.9002 15.809 9.4813V1.5813Z"
        fill="#007AB8"
      />
    </SvgIcon>
  );
}

export default CcfElevatedEmailIcon;
